import React, { useState } from 'react';
import { Upload, X, Loader2 } from 'lucide-react';
import { uploadImage } from '../../utils/api';

export default function ImageUploadField({ value, onChange, label = 'Image' }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setError('');
    setUploading(true);
    try {
      const res = await uploadImage(file);
      onChange(res.url);
    } catch (err) {
      setError(err.response?.data?.detail || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <label className="block text-sm font-medium text-slate-700 mb-2">{label}</label>
      <div className="flex items-start gap-4">
        {value ? (
          <div className="relative w-28 h-28 rounded-xl overflow-hidden border border-slate-200 flex-shrink-0">
            <img src={value} alt="preview" className="w-full h-full object-cover" />
            <button
              type="button"
              onClick={() => onChange('')}
              className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ) : (
          <label className="w-28 h-28 rounded-xl border-2 border-dashed border-slate-300 flex flex-col items-center justify-center cursor-pointer hover:border-orange-400 transition-colors flex-shrink-0">
            {uploading ? (
              <Loader2 className="h-6 w-6 text-orange-500 animate-spin" />
            ) : (
              <>
                <Upload className="h-6 w-6 text-slate-400" />
                <span className="text-xs text-slate-500 mt-1">Upload</span>
              </>
            )}
            <input type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid="image-upload-input" />
          </label>
        )}
        <div className="flex-1">
          <input
            type="text"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Or paste an image URL"
            className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:ring-2 focus:ring-orange-400 focus:border-transparent outline-none"
          />
          <p className="text-xs text-slate-400 mt-1">Upload a file (max 5MB) or paste an image URL</p>
          {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
        </div>
      </div>
    </div>
  );
}
